import { useCallback, useEffect, useState } from 'react';
import { readStorage, writeStorage } from './storage';

export type Theme = 'light' | 'dark';
const STORAGE_KEY = 'sa.theme';

function systemTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function readStoredTheme(): Theme {
  const stored = readStorage(STORAGE_KEY);
  return stored === 'dark' || stored === 'light' ? stored : systemTheme();
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
}

/** Thème clair par défaut, sombre mémorisé par utilisateur (DS-002). */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => readStoredTheme());

  useEffect(() => {
    applyTheme(theme);
    writeStorage(STORAGE_KEY, theme);
  }, [theme]);

  const toggle = useCallback(
    () => setTheme((current) => (current === 'dark' ? 'light' : 'dark')),
    [],
  );
  return { theme, setTheme, toggle };
}
